import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { FormBuilder, FormGroup } from '@angular/forms'
import { SharedServices } from '../../../../../services/shared.services'
import { ModalService } from '../../../../../services/modal.service'
import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { mongoObjectId } from '@helpers/common'

@Component({
    selector: 'app-modal-list-note-top',
    templateUrl: './modal-list-note-top.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/main-view.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
        './modal-list-note-top.component.css',
        '../../../../../stagingcss/lui-select.component.css',
    ],
})

export class ModalListNoteTopComponent implements OnInit {

    modalListNote = 'hidden'
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    en = {}
    showEN = true
    idClient
    resourceUrl = 'resource'
    listDataNoteTopClient: any[] = []
    listClientNote: FormGroup
    Notes: any[] = []
    index
    hostKeyboard: String = 'ModalListNoteTopComponent-hostKeyboard'

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices) {

    }

    ngOnInit() {
        this.modalListNote = 'hidden'
        this.clientTopServices.changeEmittedListTopImageData$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalClientDetailRegistrationComponent-listDataNoteTopClient') {
                        this.modalListNote = 'active'
                        this.index = success[3]
                        if (success[1]) {
                            this.listDataNoteTopClient = success[1]
                            this.idClient = success[2]
                            for (let i = 0; i < this.listDataNoteTopClient.length; i++) {
                                const note = this.listDataNoteTopClient[i]
                                this.Notes.push(this.createItemUrl(note.title))
                            }
                        }
                    }
                }
            })
        this.validatorForm()
    }

    hidenModalListNote() {
        this.listDataNoteTopClient = []
        this.validatorForm()
        this.modalListNote = 'hidden'
        this.clientTopServices.emitChangeListTopImageData(null)
    }


    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent, ModalListNoteTopComponent: String = 'ModalListNoteTopComponent-hostKeyboard') {
        if (ModalListNoteTopComponent === this.hostKeyboard) {
            const keyPressed = event.keyCode
            if (keyPressed === 27) {
                event.preventDefault()
                this.hidenModalListNote()
            }
        }
    }


    validatorForm() {
        this.listClientNote = this.formBuider.group({
            Notes: this.formBuider.array([]),
        })
        this.Notes = this.listClientNote.get('Notes')['controls']
    }


    createItemUrl(listClientNoteForm = ''): FormGroup {
        return this.formBuider.group({
            listClientNoteForm: listClientNoteForm,
        })
    }

    addNote(event) {
        this.Notes = this.listClientNote.get('Notes')['controls']
        this.Notes.push(this.createItemUrl())
    }

    removeNote(index) {
        this.Notes.splice(index, 1)
    }

    sortNote(index, action) {
        if (action === 'up') {
            const br1 = this.Notes[index - 1]
            const br2 = this.Notes[index]
            this.Notes.splice(index - 1, 2, br2, br1)
        } else if (action === 'down') {
            const br1 = this.Notes[index]
            const br2 = this.Notes[index + 1]
            this.Notes.splice(index, 2, br2, br1)
        }
    }

    saveNote() {
        const arrayListNoteSelect = this.Notes
        const ListNoteSelect = []
        for (let i = 0; i < arrayListNoteSelect.length; i++) {
            const valueNotes = arrayListNoteSelect[i]['controls']['listClientNoteForm']['value']
            const pushEventItemDataNoteTopClient = { _id: mongoObjectId(), title: valueNotes }
            ListNoteSelect.push(pushEventItemDataNoteTopClient)
        }
        this.clientTopServices.changecheckDataAfterConfirm(true)
        const keyArrayselect = ['ModalListNoteTopComponent-ListNoteSelect', ListNoteSelect, this.index]
        this.clientTopServices.emitChange(keyArrayselect)
        this.hidenModalListNote()
    }


}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/listnote/modal-list-note-top.component.ts